import { useId } from 'react';
import { Link } from '@tanstack/react-router';

import { reportDateLabel } from '../../lib/intelligence-view';
import { AdvisorOrb } from './AdvisorOrb';
import { useIntelligenceReports } from './queries';
import { useIntelligenceAccess } from './useIntelligenceAccess';

const CARD_ORB = 40;
const EMPTY_LABEL = 'Tu equipo todavía no ha escrito informes.';

/** Inicio card: the newest report's headline for owners on Max or higher; nothing for anyone else. */
export function LatestFromTeam() {
  const allowed = useIntelligenceAccess();
  if (!allowed) return null;
  return <LatestFromTeamCard />;
}

function LatestFromTeamCard() {
  const headingId = useId();
  const latest = useIntelligenceReports().data?.data[0];
  const date = latest ? reportDateLabel(latest.createdAt, new Date()) : '';

  return (
    <section className="section" aria-labelledby={headingId}>
      <h2 className="section-label" id={headingId}>Lo último de tu equipo</h2>
      <div className="group intel-team-card">
        <div className="row intel-team-row">
          <AdvisorOrb personaId={latest?.signer.personaId ?? 'direccion'} size={CARD_ORB} />
          <div className="grow">
            {latest ? (
              <>
                <p className="row-title intel-team-headline">{latest.headline}</p>
                <p className="row-sub intel-team-byline">
                  {date ? `${date} · ` : ''}{`${latest.signer.name} · ${latest.signer.title}`}
                </p>
              </>
            ) : (
              <p className="row-sub intel-team-byline">{EMPTY_LABEL}</p>
            )}
          </div>
          <Link to="/inteligencia" className="btn small secondary intel-team-link">Ver informe</Link>
        </div>
      </div>
    </section>
  );
}
